import { render, staticRenderFns } from "./CreateMedia.vue?vue&type=template&id=42f0d500&scoped=true&"
import script from "./CreateMedia.vue?vue&type=script&lang=js&"
export * from "./CreateMedia.vue?vue&type=script&lang=js&"
import style0 from "./CreateMedia.vue?vue&type=style&index=0&id=42f0d500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0d500",
  null
  
)

export default component.exports